export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const s = String(reader.result || "");
      const i = s.indexOf(",");
      resolve(i >= 0 ? s.slice(i + 1) : s);
    };
    reader.readAsDataURL(file);
  });

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const fmtDate = (d) => {
  try { return new Date(d).toLocaleDateString(); } catch { return "—"; }
};
export const fmtDateTime = (d) => {
  try { return new Date(d).toLocaleString(); } catch { return "—"; }
};
export const isoLocalDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
